import React, {useContext} from "react";
// @ts-ignore
import {RowDivF1} from "../../styledComponents/CustomStyledComponents";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {StyledSkeletonLine} from "../../SkeletonLoader/SkeletonLoaders";

import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import Colors from "../../../assets/colors/Colors";

import { formatNumber } from "../../../services/helpers";

interface InfoBoxInterface {
    customStyle?: object,
    countryInfo?: any
};

const StyledPillContent = styled.div`
  align-items: stretch;
  background-color: ${(props: {isLife: string}) => props.isLife ? Colors.fontGray : Colors.fontWhite};
  background-opacity: 22;
  border-radius: 50px;
  color: ${(props: {isLife: string}) => props.isLife ? Colors.fontWhite : Colors.fontGray};
  display: flex;
  flex-direction: row-reverse;
  height: 100%;
  margin-top: 20px;
  padding-right: 20px;
  width: 90%;

  & .white-fill {
    background-color: ${(props: {isLife: string}) => props.isLife ? Colors.fontWhite : Colors.fontGray};;
    border-radius: 50px;
    display: flex;
    flex: 1;
    flex-direction: row;
  }

  & .pill-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-right: 5px;
    padding-left: 5px;
    white-space: nowrap;
    background-color: ${(props: {isLife: string}) => props.isLife ? Colors.fontGray : Colors.fontWhite};
    background-opacity: 22;
  }

  & .pill-label {
    font-family: DMSans-Bold;
    margin: 0 5px;
  }

  & .pill-value {
    font-family: DMSans-Light;
  }
`;

const PillWrapper: React.FC<{label: string, value: string, unit?: string}> = ({label, value, unit}) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);

    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);

    const Content = () => (
        <StyledPillContent isLife={isLife}>
            <div className='pill-content'>
                <span className='pill-label'>{label}:</span>
                <span className='pill-value'>{value} {unit}</span>
            </div>
            <div className='white-fill' />
        </StyledPillContent>
    );

    return(
        allDataLoaded ? <Content /> : <StyledSkeletonLine customStyle={{ width: '90%', marginTop: 20, height: '100%'}}/>
    )
};

const GeneralInfoBox: React.FC<InfoBoxInterface> = ({customStyle = {}, countryInfo = {}}) => {
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const color = isLife ? Colors.fontWhite : Colors.fontGray;

    const { t, i18n } = useTranslation();
    const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || '';

    const lng = getCurrentLng() === 'es' ? 'de' : getCurrentLng();

    return (
        <div style={{border: `3px solid ${color}`, display: "flex", flexDirection: "column", padding: 20, ...customStyle}}>
            <RowDivF1 style={{color: color, marginTop: 10}}>
                <div>{t('countryContainer.generalInfo.title')}</div>
            </RowDivF1>
            <PillWrapper
                label={t('countryContainer.generalInfo.pobLevel')}
                value={formatNumber(parseFloat(countryInfo.population), 2, lng) || '-'}
            />
            <PillWrapper
                label={t('countryContainer.generalInfo.penet')}
                value={formatNumber(parseFloat(countryInfo.relative_penetration), 2, lng) || '-'}
            />
            <PillWrapper
                label={t('countryContainer.generalInfo.pbiPerCap')}
                value={parseFloat(countryInfo.gdp_per_capita).toFixed(2) || '-'}
                unit='$'
            />
            <PillWrapper
                label={t('countryContainer.generalInfo.elast')}
                value={formatNumber(parseFloat(countryInfo.demand_elasticity), 4, lng) || '-'}
            />
        </div>
    )
};

export default GeneralInfoBox;
